import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "chat-header d-flex align-center justify-space-between px-6 py-4" }
const _hoisted_2 = { class: "d-flex align-center text-white text-h6" }
const _hoisted_3 = { class: "d-flex align-center px-4 py-2 chat-input-area" }

import { ref } from 'vue'
import { BaseURL } from '@/api/request'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatBox',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const input = ref('')
const sno = ref('')
const snoConfirmed = ref(false)
const messages = ref<{ from: 'user' | 'ai'; text: string }[]>([
  { from: 'ai', text: '请输入学号' }
])

function sendMessage() {
  const userMessage = input.value.trim()
  if (!userMessage) return

  messages.value.push({ from: 'user', text: userMessage })
  input.value = ''

  if (!snoConfirmed.value) {
    sno.value = userMessage
    snoConfirmed.value = true
    messages.value.push({ from: 'ai', text: `学号已记录：${sno.value}，你可以开始提问了。` })
    return
  }

  const aiMessage = { from: 'ai' as const, text: '' }
  messages.value.push(aiMessage)

  const params = new URLSearchParams({
    sno: sno.value,
    gameId: String(props.id),
    message: userMessage,
    type: '1',
  })

  const es = new EventSource(BaseURL + '/log/stream?' + params.toString())

  es.onmessage = (event) => {
    messages.value[messages.value.length - 1].text += event.data
  }

  es.onerror = () => {
    es.close()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "chat-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            icon: "mdi-robot",
            start: "",
            class: "mr-2"
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" AI 总结助手 "))
        ])
      ]),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_sheet, {
        class: "chat-window",
        height: "530",
        rounded: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["d-flex pa-2", msg.from === 'user' ? 'justify-end' : 'justify-start'])
            }, [
              (msg.from === 'ai')
                ? (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 0,
                    size: "32",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-robot" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card, {
                color: msg.from === 'user' ? 'primary-lighten-4' : 'blue-lighten-4',
                elevation: "2",
                class: "pa-3 rounded-lg",
                style: {"max-width":"75%","white-space":"pre-wrap","word-break":"break-word","font-size":"14px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(msg.text), 1)
                ]),
                _: 2
              }, 1032, ["color"]),
              (msg.from === 'user')
                ? (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 1,
                    size: "32",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-account" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_text_field, {
          modelValue: input.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
          placeholder: "请输入消息",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          class: "flex-grow-1 mr-3",
          onKeyup: _withKeys(sendMessage, ["enter"])
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: sendMessage,
          icon: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { icon: "mdi-send" })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})